import { render, staticRenderFns } from "./EmployerTrainingDetailList.vue?vue&type=template&id=740091e8&"
import script from "./EmployerTrainingDetailList.vue?vue&type=script&lang=ts&"
export * from "./EmployerTrainingDetailList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports